import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { StrategyService } from '../../services/strategy.service';
import { Pillar, Strategy } from '../../interfaces/models/strategy.model';
import { IndicatorsService } from '../../services/indicators.service';
import { tap } from 'rxjs';
import { ConfirmationService } from 'primeng/api';

import { ToastrService } from 'ngx-toastr';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { SocketService } from '../../services/socket.service';
import { AuthService } from '../../services/auth.service';
import { authUser } from '../../interfaces/auth/auth.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DirectionService } from '../../services/direction.service';
import { CustomAblePipe } from '../../pipes/able.pipe';
import { TableModule } from 'primeng/table';

import { NavTitlePipe } from '../../pipes/nav-title.pipe';
import { filterActive } from '../../utils/filter-active';

@Component({
  selector: 'app-strategic-indicator',
  standalone: true,
  imports: [
    NavTitlePipe,TableModule,
    ButtonModule,
    IconFieldModule,
    InputTextModule,
    InputIconModule,
    CommonModule,
    RouterModule,
    DropdownModule,
    FormsModule,
    RadioButtonModule,
    ConfirmPopupModule,
    TranslateModule,
    CustomAblePipe

  ],
  providers: [ConfirmationService],
  templateUrl: './strategic-indicator.component.html',
  styleUrl: './strategic-indicator.component.scss'
})
export class StrategicIndicatorComponent implements OnInit, OnDestroy {
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  displayType = 'cards'; // Default to cards view
  isViewDetailsModal = false;
  selectedViewIndicator: any = null;


  _selectedStrategyId = 0;
  set selectedStrategyId(id: any) {
    this._selectedStrategyId = id;
  }
  get selectedStrategyId() {
    return this._selectedStrategyId;
  }
  strategyOptions = [] as { name: string, strategyId: number }[];
  pillars: Pillar[] | undefined;
  indicators = [] as any[];
  ishoverd = false;
  _selectedpillarId = 0;
  hoverIndicatorId = 0;
  _searchTerm = ''
  _selectedStrategy = {} as Strategy;
  set selectedStrategy(strategy: Strategy) {
    this._selectedStrategy = strategy;

  };
  get selectedStrategy() {
    return this._selectedStrategy;
  };
  set searchTerm(term: string) {
    console.log(term);
    this.searchByNameOrInChargeName(term);
    this._searchTerm = term;
  }
  get searchTerm() {
    return this._searchTerm;
  }
  set selectedpillarId(id: number) {
    this.setSelectedpillarIdChange(id);
    this._selectedpillarId = id

  }
  get selectedpillarId() {
    return this._selectedpillarId;
  }
  dir!: 'rtl' | 'ltr';
  user!: authUser;
  goals = [] as any[];
  goalsOptions = [] as { name: string, id: number }[];
  _selectedGoalId = 0;
  filterdIndicators = [] as any[];
  activeMenuId: number | null = null;
  expandedIndicatorIds: Set<number> = new Set();
  set selectedGoalId(id: number) {
    this._selectedGoalId = id;
    if (id == 0 || id == null) {
      this.filterdIndicators = this.indicators;
    }
    else {
      this.filterdIndicators = this.indicators.filter(x => x.strategic_goal_id == id);
    }
    console.log('Filtered Indicators after goal selection:', this.filterdIndicators.length, 'Goal ID:', id);
  }
  get selectedGoalId() {
    return this._selectedGoalId;
  }
  constructor(private strategyService: StrategyService,
    private indicatorsService: IndicatorsService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private socketService: SocketService,
    private authService: AuthService,
    private translate: TranslateService,
    private directionService: DirectionService
  ) {
  }

  private allLabel(): string {
    return this.translate.instant('all') || (this.dir === 'rtl' ? 'الكل' : 'All');
  }

  private buildGoalsOptions(goals: any[]): void {
    const activeGoals = filterActive(goals);
    this.goals = activeGoals;
    this.goalsOptions = [
      { name: this.allLabel(), id: 0 },
      ...activeGoals.map((g: any) => ({ name: g.name, id: g.id }))
    ];
  }


  ngOnDestroy(): void {
    this.strategyService.setSelectedPillarIdfn(0);
  }
  ngOnInit(): void {

    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      if (this.goals?.length) {
        this.buildGoalsOptions(this.goals);
      }
    })

    //defaultStrategy selected by defualt in init
    this.selectedStrategyId = +(this.route.snapshot.paramMap.get('strategyId') ?? '0')

    this.strategyService.selectedStrategyPillars$.pipe(tap((data) => {
      console.log('StrategicIndicator-stratigyPillars', data);
    })).subscribe(pillars => {
      this.pillars = filterActive(pillars as any[]);
      this.filterdIndicators = this.indicators;
      this.selectedGoalId = 0;
    })

    this.strategyService.selectedPillarsGoals$.subscribe(goals => {
      console.log("goalsgoalsgoals", goals);
      this.buildGoalsOptions(goals);
    })
    this.route.data.subscribe(({ indicatorPageData }) => {
      this.indicators = filterActive(indicatorPageData.strategy.indicators);
      this.strategyOptions = filterActive(indicatorPageData.strategies as Strategy[]).map((x) => ({ name: x.name, strategyId: x.id }))
      this.selectedStrategy = indicatorPageData.strategy
      this.selectedStrategyId = this.selectedStrategy.id;
      this.pillars = filterActive(this.selectedStrategy.pillars as any[]);
      this.indicatorsService.setListIndicators(this.selectedStrategyId);
    })

    this.indicatorsService.filterdIndicators$.subscribe(indicators => {
      if (indicators != null) {
        this.indicators = filterActive(indicators);
        this.filterdIndicators = this.indicators;
        this.selectedGoalId = 0;
        console.log('Filtered Indicators:', this.indicators.length, this.indicators);
        // Expand all indicators by default
        this.expandedIndicatorIds = new Set(this.indicators.map((ind: any) => ind.id));
      }

    })
    this.authService.authBufferSub$.subscribe((user) => {
      this.user = user as authUser;

    })
  }
  strategyOptionsChange() {
    this.strategyService.getStrategyById(this.selectedStrategyId).subscribe((strategy: any) => {
      this.selectedStrategy = strategy['data']['strategy'] as Strategy;
      this.selectedpillarId = 0;
    })
    this.strategyService.setStrategyIdfn(this.selectedStrategyId)
    this.indicatorsService.setListIndicators(this.selectedStrategyId);
    this.socketService.setRefreshNotification(this.selectedStrategyId);

  }
  setSelectedpillarIdChange(id: number) {
    this.strategyService.setSelectedPillarIdfn(id)
    this.indicatorsService.setSelectedPillarIdfn(id);
  }

  searchByNameOrInChargeName(term: string) {
    console.log('Search term:', term);
    this.indicatorsService.setIndicateorSearchTermfn(term);
  }
  onMouseEnter(hoverIndicatorId: number) {
    this.hoverIndicatorId = hoverIndicatorId;
  }
  onMouseLeave() {
    this.hoverIndicatorId = 0;
  }
  confirmIndicatorDelete(event: Event, indiactorId: number) {
    event.stopPropagation();
    const target = event.target as HTMLElement;
    this.confirmationService.confirm({
      target: target,
      message: this.dir == 'rtl' ? 'هل تريد تأكيد المسح؟' : 'Do you want to confirm the deletion?',
      accept: () => {
        this.indicatorsService.deleteIndicator(+this.selectedStrategyId, indiactorId).subscribe(() => {
          this.indicators = this.indicators.filter(x => x.id != indiactorId);
          this.toastr.success(this.dir == 'rtl' ? 'تمت المسح ' : 'The indicator has been deleted successfully.', this.dir == 'rtl' ? 'عملية ناجحة' : 'Success');
        }, (err) => {
          this.toastr.error(err['error']['error']['message']);
        })
      },
      reject: () => {
        this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "The deletion has been canceled.", this.dir == 'rtl' ? 'الغاء' : 'Canceled');
      }
    });
  }
  accept() {
    this.confirmPopup.accept();
  }
  reject() {
    this.confirmPopup.reject();
  }
  selectPillarFn(pillarId: number) {
    this.selectedpillarId = pillarId;

  }
  selectGoalFn(goalId: number) {
    this.selectedGoalId = goalId;
  }
  
  toggleMenu(event: Event, indicatorId: number) {
    event.stopPropagation();
    event.preventDefault();
    this.activeMenuId = this.activeMenuId === indicatorId ? null : indicatorId;
  }
  
  toggleIndicatorExpand(event: Event, indicatorId: number) {
    event.stopPropagation();
    if (this.expandedIndicatorIds.has(indicatorId)) {
      this.expandedIndicatorIds.delete(indicatorId);
    } else {
      this.expandedIndicatorIds.add(indicatorId);
    }
  }
  
  isIndicatorExpanded(indicatorId: number): boolean {
    return this.expandedIndicatorIds.has(indicatorId);
  }

  closeMenu() {
    this.activeMenuId = null;
  }
  
  showIndicatorDetails(indicator: any) {
    this.selectedViewIndicator = indicator;
    this.isViewDetailsModal = true;
  }
  
  closeDetailsModal() {
    this.isViewDetailsModal = false;
    this.selectedViewIndicator = null;
  }

  /** Parse free-text targets like "الربع الأول 3.5% الربع الثاني 4% ..." into quarters. */
  parseTargetQuarters(target: string | null | undefined): { key: string; label: string; value: string }[] {
    if (!target) return [];
    const text = String(target).trim();
    if (!text) return [];

    const defs: { key: string; re: RegExp; ar: string; en: string }[] = [
      { key: 'q1', re: /(?:الربع\s*(?:الأول|الاول|1)|Q\s*1)\s*[:\-]?\s*([\d٠-٩.,]+)\s*%?/i, ar: 'الأول', en: 'Q1' },
      { key: 'q2', re: /(?:الربع\s*(?:الثاني|2)|Q\s*2)\s*[:\-]?\s*([\d٠-٩.,]+)\s*%?/i, ar: 'الثاني', en: 'Q2' },
      { key: 'q3', re: /(?:الربع\s*(?:الثالث|3)|Q\s*3)\s*[:\-]?\s*([\d٠-٩.,]+)\s*%?/i, ar: 'الثالث', en: 'Q3' },
      { key: 'q4', re: /(?:الربع\s*(?:الرابع|4)|Q\s*4)\s*[:\-]?\s*([\d٠-٩.,]+)\s*%?/i, ar: 'الرابع', en: 'Q4' },
    ];

    const quarters: { key: string; label: string; value: string }[] = [];
    for (const def of defs) {
      const match = text.match(def.re);
      if (!match?.[1]) continue;
      const raw = match[1].replace(/,/g, '.').trim();
      const withUnit = /%/.test(match[0]) || /%/.test(text) ? `${raw}%` : raw;
      quarters.push({
        key: def.key,
        label: this.dir === 'rtl' ? def.ar : def.en,
        value: withUnit,
      });
    }
    return quarters;
  }

  hasQuarterTargets(target: string | null | undefined): boolean {
    return this.parseTargetQuarters(target).length >= 2;
  }

  /** Simple target display without duplicating % when the value already includes it. */
  formatSimpleTarget(indicator: any): string {
    const t = String(indicator?.target ?? '').trim();
    if (!t) return '—';
    if (indicator?.measurement_unit === 'percentage' && !t.includes('%')) {
      return `${t}%`;
    }
    return t;
  }
}
